import React from "react";
import styled from "styled-components/macro";
import Modal from "react-modal";
import Filters from ".";
import Button from "components/Button";
import { buttonType } from "components/Button/Button";
import { batch, useDispatch, useSelector } from "react-redux";
import { hideRootModal } from "features/rootModal/rootModalSlice";
import { shadow } from "theme/GlobalElements";
import {
  selectActiveFiltersCount,
  selectFilters,
  setActiveFilters,
  setActiveFiltersCount,
  setOpenedFilter,
} from "./filtersSlice";
import { useNavigate } from "react-router-dom";
import { PageWithFilterType } from "./types";

interface FiltersModalProps {
  filteredProductsSelector: any;
  fetchFilteredProductsFN: any;
  pageType: PageWithFilterType;
  setIsOpened: (value: boolean) => void;
}

const FiltersModal: React.FC<FiltersModalProps> = ({
  fetchFilteredProductsFN,
  pageType = PageWithFilterType.category,
  setIsOpened,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filters = useSelector(selectFilters);
  const activeFiltersCount = useSelector(selectActiveFiltersCount);

  const removeFilters = () => {
    dispatch(setActiveFilters([]));
    dispatch(setActiveFiltersCount(0));
    dispatch(fetchFilteredProductsFN([]));
    navigate(`/${pageType}`);
  };

  const closeModal = () => {
    batch(() => {
      dispatch(hideRootModal());
      dispatch(setOpenedFilter(""));
    });
    setIsOpened(false);
  };

  Modal.setAppElement("#root");
  return (
    <Modal isOpen={true} onRequestClose={closeModal} style={customStyles} contentLabel="Example Modal">
      <Filters
        filters={filters}
        activeFiltersCount={activeFiltersCount}
        removeFiltersCB={removeFilters}
        pageType={pageType}
        fetchFN={fetchFilteredProductsFN}
      />
      <CloseModalButton>
        <Button rounded={false} type={buttonType.blueBtn} onClick={closeModal} title="Търси" />
      </CloseModalButton>
    </Modal>
  );
};

const CloseModalButton = styled.div`
  ${shadow};
  margin-top: 20px;
  margin-bottom: 10px;
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "10px",
    maxHeight: "65vh",
  },

  overlay: {
    backgroundColor: "rgb(0 0 0 / 67%)",
    zIndex: 3,
  },
};

export default FiltersModal;
